/**
 * Owner: Masa Bayu
 * File: qxp-codes.ts
 * Date:Time: 2026-09-14 20:33
 * Description: QXP Core vocabulary for 28A — publication refs, not QXW SoT.
 */
/** Native publication format — QXP ≠ QXW. */
export const QXP_FORMAT = 'QXP';
/** Locked QXP format version for the 28A core contract. */
export const QXP_VERSION = '1.0.0';
export const QXP_CORE_MODEL_VERSION = '1.0.0';
export const QXP_CONTENT_REF_KINDS = [
    'document',
    'chapter',
    'section',
    'text',
    'table',
    'other',
];
export const QXP_STRUCTURE_REF_KINDS = ['root', 'chapter', 'section', 'heading', 'other'];
export const QXP_LAYOUT_REF_KINDS = ['page', 'spread', 'region', 'other'];
export const QXP_DESIGN_REF_KINDS = ['theme', 'style-token', 'component', 'other'];
export const QXP_ASSET_REF_KINDS = ['image', 'audio', 'video', 'font', 'file', 'other'];
export const QXP_NAVIGATION_REF_KINDS = ['toc', 'landmark', 'link', 'spine', 'other'];
export const QXP_ACCESSIBILITY_REF_KINDS = [
    'alt-text',
    'aria-label',
    'reading-order',
    'caption',
    'other',
];
export const QXP_DIAGNOSTIC_SEVERITIES = ['error', 'warning', 'info'];
export const QXP_CORE_CODES = [
    'QXP_FORMAT_INVALID',
    'QXP_VERSION_UNSUPPORTED',
    'QXP_PACKAGE_REQUIRED',
    'QXP_PUBLICATION_REQUIRED',
    'QXP_REF_DUPLICATE',
    'QXP_REF_KIND_UNKNOWN',
    'QXP_INTEGRITY_INVALID',
    'QXP_LEAKAGE',
];
export const QXP_CORE_MESSAGE_KEYS = {
    QXP_FORMAT_INVALID: 'qxp.core.format.invalid',
    QXP_VERSION_UNSUPPORTED: 'qxp.core.version.unsupported',
    QXP_PACKAGE_REQUIRED: 'qxp.core.package.required',
    QXP_PUBLICATION_REQUIRED: 'qxp.core.publication.required',
    QXP_REF_DUPLICATE: 'qxp.core.ref.duplicate',
    QXP_REF_KIND_UNKNOWN: 'qxp.core.ref.kind-unknown',
    QXP_INTEGRITY_INVALID: 'qxp.core.integrity.invalid',
    QXP_LEAKAGE: 'qxp.core.leakage',
};
export const QXP_DIAGNOSTIC_CODES = [
    'QXP_CORE_IDENTITY_READY',
    'QXP_CORE_REFS_READY',
    'QXP_CORE_INTEGRITY_READY',
    'QXP_CORE_VALIDATION_PASS',
    'QXP_CORE_VALIDATION_FAIL',
];
export const QXP_DIAGNOSTIC_MESSAGE_KEYS = {
    QXP_CORE_IDENTITY_READY: 'qxp.core.diagnostic.identity-ready',
    QXP_CORE_REFS_READY: 'qxp.core.diagnostic.refs-ready',
    QXP_CORE_INTEGRITY_READY: 'qxp.core.diagnostic.integrity-ready',
    QXP_CORE_VALIDATION_PASS: 'qxp.core.diagnostic.validation-pass',
    QXP_CORE_VALIDATION_FAIL: 'qxp.core.diagnostic.validation-fail',
};
//# sourceMappingURL=qxp-codes.js.map